import { Resource } from "i18next";
import t from "../../locales/es.json";

export default t as Resource;
